import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-card',
  templateUrl: './default-card.component.html',
  styleUrls: ['./default-card.component.scss']
})
export class DefaultCardComponent implements OnInit {
  @Input() showThisComponent = true;
  @Input() showChildComponent = true;
  @Input() title: string;
  @Input() titleDetail: string;
  @Input() info: string;
  @Input() error: boolean;
  @Input() errorMessage = '';
  @Input() type_class: 'aligner' | 'notice--outlined' | 'notice--left' = null;
  // sizes: normal, large
  @Input() size: 'normal' | 'large' = 'normal';
  @Input() isCollapsible = false;
  @Input() collapsibleDescription: string;
  @Input() collapsibleIsExpanded = true;
  @Input() hideInfoWrapper = false;

  constructor() {}

  ngOnInit(): void {}
}
